import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/store";
import { fetchStaffCountAsync } from "../../../store/thunks/staffCountThunk";
import { useNavigate } from "react-router";
import { updateIndex } from "../../../store/slices/sideMenuSlice";

import {
  DashboardConstants,
  UserStatus,
  pageRouteConstants,
} from "../../../constants/constants";
import { saveActiveTabIndex } from "../../../store/slices/rolesSlice";
import DashboardWebComponent from "./DashboardWebComponent";
import DashboardMobileComponent from "./DashBoardMobileComponent";
import { validatePendingStaffData } from "../../../store/slices/validatePendingStaffSlice";
import { resetStaffList, setKey } from "../../../store/slices/staffListSlice";
import { useTranslation } from "react-i18next";
import { read } from "fs";
import { readFromLocalStorage } from "../../../utils/DataEncryption";
export interface StaffCountData {
  activeStaff: number;
  conflictingStaff: number;
  pendingStaff: number;
  totalStaff: number;
}
const Dashboard = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [state, setState] = useState(false);

  const dispatch = useDispatch<AppDispatch>();

  const staffCount: StaffCountData | null = useSelector(
    (state: RootState) => state.staffCount.staffCount
  );
  const pendingStaff: validatePendingStaffData = useSelector(
    (state: RootState) => state.validatePendingStaffData
  );
  const countStatus = useSelector((state: RootState) => state.validatePendingStaffData?.updateStatus);
  useEffect(() => {
    dispatch(saveActiveTabIndex(0));
  }, [state, dispatch, staffCount]);

  useEffect(() => {
    dispatch(fetchStaffCountAsync());
  }, [dispatch,countStatus]);

  const keyMap: Record<any, any> = {
    activeStaff: UserStatus.ACTIVE,
    pendingStaff: UserStatus.PENDING,
    conflictingStaff: UserStatus.CONFLICT,
    totalStaff: "",
  };
  const TitleMap: Record<any, any> = {
    activeStaff: "Active Staff",
    conflictingStaff: "Conflicting User",
    pendingStaff: "Pending Staff",
    totalStaff: "Total Staff",
  };

  const quickLinksDataInDashBoard = [
    {
      title: DashboardConstants.addNewStaff,
      description: DashboardConstants.addNewStaffDescription,
      link: pageRouteConstants.onboardRoute,
    },
    {
      title: "Employee List",
      description: "Click to navigate to staff list",
      link: pageRouteConstants.staffListRoute,
    },

    // {title:DashboardConstants.verifyStaff,description:DashboardConstants.verifyStaffDescription,link:""},
    // {title:DashboardConstants.assignApplication,description:DashboardConstants.assignApplicationDescription,link:""},
    // {title:DashboardConstants.manageRoles,description:DashboardConstants.manageRolesDescription,link:""}
  ];
  const applications = JSON.parse(readFromLocalStorage("applications") || "[]");

  const quickLinksData =
    Array.isArray(applications) &&
    applications.some((app: string) =>
      ["salesmate-app", "salesmate-asa-app"].includes(app)
    )
      ? quickLinksDataInDashBoard.slice(1)
      : quickLinksDataInDashBoard;

  const handleTileClick = (key: string) => {
    setTimeout(() => {
      dispatch(resetStaffList()); // Set the key in the state
      dispatch(updateIndex(1));
      dispatch(setKey(keyMap[key]));
      navigate(`/staffList?key=${keyMap[key]}&title=${TitleMap[key]}`);
    }, 2000);
  };
  return (
    <>
      <div className="block lg:hidden">
        <DashboardMobileComponent
          staffCount={staffCount}
          TitleMap={TitleMap}
          quickLinksData={quickLinksData}
          navigate={navigate}
          isLoading={pendingStaff.loading}
          handleTileClick={handleTileClick}
        />
      </div>
      <div className="hidden lg:block">
        <DashboardWebComponent
          staffCount={staffCount}
          TitleMap={TitleMap}
          quickLinksData={quickLinksData}
          navigate={navigate}
          isLoading={pendingStaff.loading}
          handleTileClick={handleTileClick}
        />
      </div>

    </>
  );
};

export default Dashboard;
